import { render } from "./TabBar.vue?vue&type=template&id=75df3a94&scoped=true"
import script from "./TabBar.vue?vue&type=script&lang=js"
export * from "./TabBar.vue?vue&type=script&lang=js"

import "./TabBar.vue?vue&type=style&index=0&id=75df3a94&scoped=true&lang=scss"

import exportComponent from "D:\\建龙工作\\开发项目\\VUE程序包\\宿舍报修系统\\bxxt\\bxxt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75df3a94"]])

export default __exports__